// Single source of truth for the Allure app version.
//
// - VERSION_NAME is the user-facing semantic version (e.g. "1.0.0").
// - VERSION_CODE is a monotonic integer that MUST be bumped every time you
//   produce a new Android/iOS build so Play Store / App Store can tell builds
//   apart. PWABuilder reads this via the manifest when regenerating the AAB.
//
// When you re-deploy without rebuilding the native wrapper, bump VERSION_NAME
// only. When you regenerate the AAB / IPA, bump BOTH.
export const VERSION_NAME = '1.0.0';
export const VERSION_CODE = 1;
export const BUILD_CHANNEL = 'preview'; // 'preview' | 'production'

export const VERSION_LABEL = `v${VERSION_NAME} (build ${VERSION_CODE})`;
